import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { getLocationMap } from '@/services/api';
import { getLocalText } from '@/utilities/language';
import { traceOnError } from '@/tracer';
var defaultAnswer = {
  location: [],
  type: 'location'
};
var LocChoice = /*#__PURE__*/function (_React$Component) {
  _inherits(LocChoice, _React$Component);
  function LocChoice(props) {
    var _this;
    _classCallCheck(this, LocChoice);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocChoice).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getLocationMap", function () {
      var question = _this.props.question;
      var custom = question.custom;
      var _custom$country = custom.country,
        country = _custom$country === void 0 ? 'cn' : _custom$country;
      getLocationMap(country).then(function (res) {
        return _this.setState({
          locationMap: res.data
        });
      }).catch(function (e) {
        traceOnError("".concat(e.message, "-").concat(window.location.href), e.code, 'Loc接口');
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var required = _this.props.question.required;
      if (required && answer.location.length === 0) {
        callback(getLocalText('SingleChoice.Selected')); // '请填写答案
        return;
      }
      callback();
    });
    _this.state = {
      locationMap: []
    };
    _this.getLocationMap();
    return _this;
  }
  _createClass(LocChoice, [{
    key: "getLocChange",
    value: function getLocChange(location) {
      return {
        location: location,
        type: 'location'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        question = _this$props.question,
        _this$props$answer = _this$props.answer,
        answer = _this$props$answer === void 0 ? JSON.parse(JSON.stringify(defaultAnswer)) : _this$props$answer;
      var custom = question.custom;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: _objectSpread({}, answer),
          rules: [{
            required: true,
            validator: this.validator
          }]
        }),
        _onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      var options = this.state.locationMap;
      if (custom && custom.hideDistrict) {
        options.forEach(function (province) {
          if (province.children && Array.isArray(province.children)) {
            province.children.forEach(function (city) {
              if (city.children) {
                delete city.children;
              }
            });
          }
        });
      }
      if (custom && custom.provinceLock) {
        options = options.filter(function (el) {
          return el.value === custom.provinceLock;
        });
        if (!custom.hideDistrict && custom.cityLock && options[0] && options[0].children) {
          options[0].children = options[0].children.filter(function (item) {
            return item.value === custom.cityLock;
          });
        }
      }
      var error = getFieldError(id);
      if (error && error.length > 0) error = error.join(',');else error = null;
      var params = {
        options: options,
        error: error,
        formAnswer: formAnswer,
        onChange: function onChange(val) {
          return _onChange(_this2.getLocChange(val));
        }
      };
      return this.props.children(params);
    }
  }]);
  return LocChoice;
}(React.Component);
export { LocChoice as default };